module.exports = __webpack_public_path__ + "7b4234b49cbb2a09b544a58d7dab1f08.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-ice-queen-s.png
// module id = 2690
// module chunks = 0